import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { OptionalHolidayFormComponent } from '../optional-holiday-form/optional-holiday-form.component';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OptionalHolidayService } from '../../../Model/OptionalHoliday/optional-holiday.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { RouterOutlet, RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import moment from 'moment';

@Component({
  selector: 'app-optional-holiday',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NgbDatepickerModule, FormsModule, JsonPipe, DataTablesModule, NgbDropdownModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './optional-holiday.component.html',
  styleUrl: './optional-holiday.component.scss'
})
export class OptionalHolidayComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Years = [] as any;
  Users = [] as any;
  Filter = {
    SelectType: 2,
    EmpMasterID: 0,
    ESS_EmployeeOptionalHolidayId: 0,
    FromDateObj: null as any,
    ToDateObj: null as any,
    FromDate: null as any,
    ToDate: null as any,
    ApprovalStatus: 'ALL',
    IsWithdraw: false
  }

  OPHolidays = []
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private utility: UtilityService,
    private modalService: NgbModal,
    private optionalholiday: OptionalHolidayService,
    private session: SessionService,
    private dateFormat: CustomDateParserFormatter,
    private toast: ToastService,
    private tooltip: TooltipService
  ) {
    this.Users = session.GetUserDetails();
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.Search();
    }
    else {
      form.submitted = true;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.FromDateObj.month = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = 31;
          this.Filter.ToDateObj.month = 12;
          //this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.Search();
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  Apply() {
    const modalRef = this.modalService.open(OptionalHolidayFormComponent);
    modalRef.result.then(
      (result: any) => { },
      () => { }
    );
  }

  Search() {
    if (this.Filter.IsWithdraw) {
      this.ESS_EmployeeOptionalHolidayWithdrawLoad();
    } else {
      this.ESS_EmployeeOptionalHolidayLoadGet();
    }
  }

  ESS_EmployeeOptionalHolidayLoadGet() {
    if (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY'))) {
      this.isDisabled = true;
      this.Filter.EmpMasterID = this.Users.UserId;
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
      this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
      this.optionalholiday.ESS_EmployeeOptionalHolidayLoadGet(this.Filter).subscribe({
        next: (response) => {
          try {
            if (response.Table.length > 0) {
              this.OPHolidays = response.Table
            } else {
              this.OPHolidays = []
            }
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          } catch (e) {
            this.OPHolidays = []
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ESS_EmployeeOptionalHolidayWithdrawLoad() {
    this.isDisabled = true;
    this.Filter.EmpMasterID = this.Users.UserId;
    this.optionalholiday.ESS_EmployeeOptionalHolidayWithdrawLoad({ SelectType: 1, EmpMasterID: this.Filter.EmpMasterID, ESS_EmployeeOptionalHolidayID: 0 }).subscribe({
      next: (response) => {
        try {
          if (response.Table.length > 0) {
            this.OPHolidays = response.Table
          } else {
            this.OPHolidays = [];
          }
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) {
          this.OPHolidays = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeOptionalHolidaySave(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsAdd) {
        if (result) {
          this.isDisabled = true;
          this.optionalholiday.ESS_EmployeeOptionalHolidaySave({
            SelectType: 'Withdraw',
            ESS_EmployeeOptionalHolidayId: this.OPHolidays[index]['ESS_EmployeeOptionalHolidayId'], EmpMasterID: this.Filter.EmpMasterID,
            ESS_CompanyHolidayMasterID: 0, SiteId: 0, BranchId: 0,
            Remarks: null
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '406') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.ESS_EmployeeOptionalHolidayLoadGet();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  Clear() {
    this.OPHolidays = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
